import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const PapuaNewGuineaFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15743'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15743)'>
				<rect
					width='20'
					height='14'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0H20V14L0 0Z'
					fill='#E8283F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.76097 11.6667L4.08754 11.86L4.28478 11.2001L4.08754 10.5401L4.76097 10.7334L5.43441 10.5401L5.23717 11.2001L5.43441 11.86L4.76097 11.6667Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.76097 6.06663L4.08754 6.25993L4.28478 5.59996L4.08754 4.93999L4.76097 5.13329L5.43441 4.93999L5.23717 5.59996L5.43441 6.25993L4.76097 6.06663Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M2.38012 8.4L1.70668 8.5933L1.90392 7.93333L1.70668 7.27337L2.38012 7.46667L3.05355 7.27337L2.85631 7.93333L3.05355 8.5933L2.38012 8.4Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66722 7.93333L5.99379 8.12662L6.19103 7.46666L5.99379 6.80669L6.66722 6.99999L7.34066 6.80669L7.14342 7.46666L7.34066 8.12662L6.66722 7.93333Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M13.4721 6.48593C13.3581 6.41889 13.2657 6.26097 13.2657 6.13463L13.2657 5.27453C13.2657 5.14755 13.1724 5.07506 13.0314 5.12115L12.4898 5.29806C12.3604 5.34033 12.1623 5.34414 12.0212 5.29806L11.4796 5.12115C11.3503 5.07888 11.3359 4.99139 11.4518 4.92322L12.7225 4.17605C12.8365 4.10901 12.8979 3.9633 12.8508 3.82506L12.6703 3.29432C12.6272 3.16751 12.6854 3.09517 12.8265 3.14125L13.3681 3.31816C13.4975 3.36043 13.6567 3.30599 13.7262 3.19238L14.4887 1.94709C14.5571 1.83536 14.6436 1.83614 14.6906 1.97438L14.8712 2.50513C14.9143 2.63193 14.9182 2.82609 14.8712 2.96433L14.6906 3.49508C14.6475 3.62188 14.7182 3.72468 14.8471 3.72468H15.7248C15.8544 3.72468 16.0137 3.81339 16.0833 3.92699L16.8457 5.17228C16.9141 5.28402 16.8591 5.39625 16.7355 5.42048L15.5201 5.6587C15.3908 5.68404 15.2639 5.81283 15.2391 5.93399L14.9961 7.12508C14.9702 7.25178 14.8587 7.30127 14.7428 7.23311L13.4721 6.48593Z'
					fill='#FFD84E'
				/>
			</g>
		</svg>
	);
};

export default PapuaNewGuineaFlagIcon;
